/**
 *
 * Loader
 *
 */

import "./styles.scss";

import { MagicSpinner } from "react-spinners-kit";
import React from "react";
// @ts-ignore
import Variables from "styles/variables.scss";
import { connect } from "react-redux";

export class Loader extends React.Component<any, any> {
	componentDidUpdate(prevProps: any) {
		const { loader } = this.props;

		if (prevProps.loader !== loader) {
			if (loader) {
				document.body.classList.add("--app-loading");
			} else {
				document.body.classList.remove("--app-loading");
			}
		}
	}

	render() {
		const { loader } = this.props;

		return (
			<div className={`Loader${loader ? " --visible" : ""}`}>
				<MagicSpinner color={Variables.primaryColor} size={120} />
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	loader: state.loader
});

export default connect(mapStateToProps)(Loader);
